import React from "react";

export default function NavBar() {
  return (
    <nav className="navbar navbar-expand-lg  bg-body-tertiary">
      <div className="container-fluid">
        <a className="navbar-brand" href="/">
          Add to Cart By Aman
        </a>
      </div>
    </nav>
  );
}
